import {
  RECEIVE_ITEM_SEARCH_DATA, REQUEST_ITEM_SEARCH_DATA, ERROR_ITEM_SEARCH_DATA, RESET_ITEM_SEARCH_DATA
} from '../actions/searchDataActions';
import initialState from './initialState';

export default function searchDataReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.searchData;
  }

  if (type === REQUEST_ITEM_SEARCH_DATA) {
    return { ...state, itemSearch: { loading: true, error: { show: false, message: '' }, data: {} } };
  }

  if (type === RECEIVE_ITEM_SEARCH_DATA) {
    return {
      ...state, itemSearch: { data, loading: false }
    };
  }

  if (type === ERROR_ITEM_SEARCH_DATA) {
    return { ...state, itemSearch: { loading: false, error: { show: true, message: data }, data: {} } };
  }

  if (type === RESET_ITEM_SEARCH_DATA) {
    return { ...state, itemSearch: { ...state.itemSearch, data: {} } };
  }

  return state;
}
